/**
 * legal_content.js
 * Legal texts for Privacy Policy and Terms of Use.
 */

export const LEGAL_CONTENT = {
    privacy: {
        title: "Privacy Policy",
        lastUpdated: "January 30, 2026",
        content: `
            <h3>1. Data Collection</h3>
            <p>Madmoco Arcade is a client-side gaming portal. Most games process data entirely within your browser and do not send information to any server.</p>
            
            <h3>2. Analytics</h3>
            <p>If you consent, we use Google Analytics to collect anonymous usage data (e.g., which games are most played). This helps us prioritize improvements. We anonymize your IP address.</p>
            
            <h3>3. Local Storage</h3>
            <p>We use browser local storage to save your preferences, such as your dark mode setting and cookie consent. This data stays on your device.</p>
            
            <h3>4. Third Parties</h3>
            <p>We do not sell, trade, or otherwise transfer your information to outside parties.</p>

            <h3>5. Contact</h3>
            <p>For any questions regarding your privacy, contact us at: <strong>info@arcade.madmoco.com</strong></p>
        `
    },
    cookies: {
        title: "Cookie Policy",
        lastUpdated: "January 30, 2026",
        content: `
            <h3>1. What are cookies?</h3>
            <p>Cookies are small text files stored on your device that help us provide a better experience.</p>
            
            <h3>2. Cookies We Use</h3>
            <ul>
                <li><strong>Strictly Necessary:</strong> We use local storage to remember your game settings and your cookie consent choice.</li>
                <li><strong>Analytics:</strong> With your permission, we use Google Analytics (_ga) to collect anonymous data about game popularity and usage.</li>
            </ul>
            
            <h3>3. Managing Cookies</h3>
            <p>You can revoke your consent at any time by clearing your browser's local storage or using the settings in your browser.</p>
        `
    },
    terms: {
        title: "Terms of Use",
        lastUpdated: "January 30, 2026",
        content: `
            <h3>1. Use of License</h3>
            <p>Madmoco Arcade is provided "as is". You are free to play these games for personal or competitive purposes.</p>
            
            <h3>2. Disclaimer</h3>
            <p>The games provided are for convenience. Madmoco is not responsible for any issues or errors caused by the output of these games.</p>
            
            <h3>3. Modifications</h3>
            <p>We reserve the right to modify or remove games at any time to improve the arcade experience.</p>

            <h3>4. Contact</h3>
            <p>For any legal or technical inquiries, reach out to: <strong>info@arcade.madmoco.com</strong></p>
        `
    }
};
